import React, { useEffect } from "react";

// components
import SectionContainer from "core/SectionContainer";
import Faq from "core/Faq";
import TextWithButton from "core/TextWithButton";
import IllustrativeHero from "core/IllustrativeHero";
import Organization from "core/ReusableIcons/Organization";
import IconsSection from "marketing-pages/PricingMarketingPage/IconsSection";
import OffsetGrid from "core/OffsetGrid";
import PageMeta from "core/PageMeta";

// styles
import colors from "core/colors";
import { Image } from "./styles";

// data
import { svgSizes } from "subscriptions/data";
import {
    metaTitle,
    metaDescription,
    mainHeroTitle,
    headingTitle,
    subTextTitle,
    heroButtons,
    sections,
    heroSubTitle,
    highlightTeamColumn,
    faqTitle,
    faqValues
} from "./data";

const NounProTeam = () => {
    useEffect(() => {
        // We need to manually take control of the browsers scrollRestoration
        window.history.scrollRestoration = "manual";

        if (window.pageYOffset !== 0) {
            window.scrollTo(0, 0);
        }
    }, []);

    return (
        <>
            <PageMeta title={metaTitle} removeDescriptionTag>
                <meta name="description" content={metaDescription} />
            </PageMeta>
            <SectionContainer bgColor={colors.midnight}>
                <Image alignment="center">
                    <Organization size={svgSizes} fillColor={colors.mist} />
                </Image>
                <TextWithButton
                    headingColor={colors.mist}
                    headingAlignment="center"
                    headingType="h1"
                    headingSize="3xl"
                    headingBottomSpacing="xl"
                    subtextColor={colors.mist}
                    text={mainHeroTitle}
                    subtext={heroSubTitle}
                    buttons={heroButtons}
                />
            </SectionContainer>

            <SectionContainer bgColor={colors.mist}>
                <OffsetGrid sm={10} md={12} lg={12}>
                    <TextWithButton
                        text={headingTitle}
                        subtext={subTextTitle}
                        headingAlignment="center"
                        subtextAlignment="center"
                        bottomSpacing="xl"
                        headingType="h2"
                        headingSize="xl"
                    />
                    <IllustrativeHero sections={sections} alignment="center" />
                </OffsetGrid>
            </SectionContainer>

            <IconsSection bestValueHighlight={highlightTeamColumn} />

            <SectionContainer bgColor={colors.mist}>
                <OffsetGrid sm={10} md={12} lg={12}>
                    <Faq
                        title={faqTitle}
                        values={faqValues}
                        headingAlignment="left"
                    />
                </OffsetGrid>
            </SectionContainer>
        </>
    );
};

export default NounProTeam;
